<template>
  <v-dialog
    :max-width="width"
    persistent
    z-index="99999"
    value="true"
    @input="change"
  >
    <template
      v-if="!!title"
    >
      <div
        v-if="theme === 'title-flat'"
        class="title text-xs-center pt-3 white"
      >
        <div
          v-html="title"
        />
      </div>
      <v-toolbar
        v-else
        :color="color"
        dark
        dense
      >
        <v-icon v-if="!!icon">
          {{ icon }}
        </v-icon>
        <v-toolbar-title
          class="white--text"
          v-text="title"
        />
      </v-toolbar>
    </template>
    <v-card
      tile
      flat
    >
      <v-card-text
        class="subheading confirmText"
      >
        <div v-html="message" />

        <template v-if="subContent">
          <v-divider
            class="my-2"
          />
          <div v-html="subContent" />
        </template>
        <div
          v-if="neverShowKey"
          class="checkbox"
        >
          <v-checkbox
            v-model="neverShow"
            label="下次不再顯示"
            hide-details
          />
        </div>
      </v-card-text>

      <div
        v-if="buttons && buttons.length"
        class="text-center pt-2"
      >
        <div
          v-for="button in buttons"
          :key="button.text"
        >
          <v-btn
            v-bind="button.props"
            class="mb-3"
            @click="choose(button.value)"
          >
            {{ button.text }}
          </v-btn>
        </div>
      </div>
      <template v-else>
        <v-divider />

        <v-card-actions class="pa-0">
          <v-flex
            v-if="buttonFalseText"
            style="border-right: 1px solid rgba(0, 0, 0, 0.12);"
          >
            <v-btn
              :color="buttonFalseColor"
              flat
              large
              block
              @click="choose(false)"
            >
              {{ buttonFalseText }}
            </v-btn>
          </v-flex>
          <v-flex
            v-if="buttonTrueText"
          >
            <v-btn
              :color="buttonTrueColor"
              flat
              block
              large
              @click="choose(true)"
            >
              {{ buttonTrueText }}
            </v-btn>
          </v-flex>
        </v-card-actions>
      </template>
      <!--
      <v-card-actions>
        <v-spacer/>
        <v-btn
          v-if="buttonTrueText"
          :color="buttonTrueColor"
          flat
          @click="choose(true)">{{ buttonTrueText }}</v-btn>
        <v-btn
          v-if="buttonFalseText"
          :color="buttonFalseColor"
          flat
          @click="choose(false)">{{ buttonFalseText }}</v-btn>
      </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    buttonTrueText: {
      type: String,
      default: 'Yes'
    },
    buttonFalseText: {
      type: String,
      default: 'No'
    },
    buttonTrueColor: {
      type: String,
      default: 'primary'
    },
    buttonFalseColor: {
      type: String,
      default: 'grey'
    },
    color: {
      type: String,
      default: 'warning'
    },
    icon: {
      type: String,
      default: 'warning'
    },
    titleClass: {
      type: String,
      default: '', // title-flat
    },
    theme: {
      type: String,
      default: '', // title-flat
    },
    message: {
      type: String,
      reqiured: true
    },
    title: {
      type: String
    },
    width: {
      type: Number,
      default: 300
    },
    buttons: {
      type: Array,
      default: () => []
    },
    subContent: {
      type: String
    },
    neverShowKey: {
      type: String
    }
  },
  data () {
    return {
      value: false,
      neverShow: '',
    }
  },
  methods: {
    choose (value) {
      if (this.neverShowKey && this.neverShow) {
        localStorage[this.neverShowKey] = '1'
      }
      this.$emit('result', value)
      this.value = value
      this.$destroy()
    },
    change (res) {
      this.$destroy()
    }
  }
}
</script>
<style lang="postcss" scoped>
/* 弹窗固定 300px 宽，讯息里的 IPv6 / 网址 / 单号等无空格长串允许任意位置换行，否则 v-dialog 会出现横向卷轴 */
.confirmText {
  overflow-wrap: anywhere;
  word-break: break-word;
}
.checkbox {
  transform: scale(0.9);
  transform-origin: left;
}
</style>
